<template>
  <div class="ada-distribute g-container">
    <Breadcrumb class="bread">
      <BreadcrumbItem> <Icon type="ios-home-outline"></Icon> 选择投放账号 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="logo-buffer"></Icon> 设置计划 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="ios-cafe"></Icon> 设置创意 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="md-options"></Icon> 批量确认 </BreadcrumbItem>
    </Breadcrumb>

    <div class="config-wrapper">
      <div class="plan-tabs">
        <div class="tab-info">
          <h5>批量计划配置</h5>
        </div>
        <div class="opertions">
          <div class="tags">
            <el-tag
              v-for="acc in adAccounts"
              :type="activeAccountId === acc.id ? '' : 'info'"
              @click="onAccountTabChange(acc)"
              :key="acc.id"
            >
              {{ acc.name }}
            </el-tag>
          </div>

          <div class="btns">
            <el-button @click="onDistributeRowsRemove">批量删除</el-button>
          </div>
        </div>
      </div>

      <div class="table-content" v-if="filterdPreviewTableData">
        <Viewport v-model="previewTableHeight">
          <PreviewTable
            ref="previewTable"
            :selections.sync="tableSelections"
            :height="previewTableHeight"
            :data.sync="filterdPreviewTableData"
            :object-span-method="objectSpanMethod"
          ></PreviewTable>

          <div class="footer-row">
            <div class="switch">
              <span> 项目计划开关&ensp;</span>
              <el-switch v-model="projectState"></el-switch>
            </div>
            <el-button @click="onDistributeBackWard">上一步</el-button>
            <el-button type="primary" @click="onPlanSubmit" :loading="submitLoading">确认提交</el-button>
          </div>
        </Viewport>
      </div>
    </div>
  </div>
</template>
<script>
import { clone, groupBy } from '@/common/js/just.js'
import { getSession, clearSession } from '@/common/js/api.js'
import { adAccount } from '@/api/common.model'
import { submitTencentV3Plans, submitTencentV3AddCreatives } from '@/api/tencentada.model.js'
import { getDefaultCheckStates, makeV3InnerPlanParams, makeV3CreativeParams, makeV3OuterPlanParams } from '../model/distribute-form.js'
import PreviewTable from '../components/distribute/preview-table.vue'
import { SITE_ENUM } from '../model/siteset/siteset-const.js'
import { PLATFORM } from '../model/project-const.js'
const rowSpanExcludeLabels = ['定向包', '创意组', '品牌形象跳转', '落地页', '操作']
let regionList = []
export default {
  components: { PreviewTable },
  provide() {
    return {
      parentInstance: this
    }
  },
  data() {
    return {
      accountList: [], // 媒体账号列表
      rowSpan: {}, // 根据定向名称分组合并的单元格
      submitLoading: false,
      projectState: false,
      tableSelections: [],
      projectInfo: {},
      previewTableData: {}, // {5165: [], 3232: []} 根据账号id为key，来筛选出对应的计划数据
      activeAccountId: 0,
      previewTableHeight: 500,

      addCreativeFlag: false // 是否在已有计划下新增创意
    }
  },
  async created() {
    await this.getAccountList()
    this.getProjectInfo()

    fetch('/data/tencent_region.json')
      .then((res) => res.json())
      .then((data) => {
        regionList = data
      })
  },
  computed: {
    adAccounts() {
      const accounts = this.projectInfo.planForm?.accounts || []
      const adAccounts = this.accountList.filter((acc) => accounts.includes(acc.id))
      return adAccounts
    },
    siteSets() {
      return this.projectInfo.planForm.siteSet || []
    },
    hasMoment() {
      return this.siteSets.includes(SITE_ENUM.MOMENTS)
    },
    // 是否单视频号版位
    isChannels() {
      return this.siteSets.includes(SITE_ENUM.CHANNELS) && this.siteSets.length === 1
    },
    planLens() {
      let lens = 0
      for (const i in this.previewTableData) {
        lens += this.previewTableData[i].length
      }
      return lens
    },
    /**
     * @description: 根据账号过滤的预览表格数据
     * @return {*}
     */
    filterdPreviewTableData: {
      get() {
        return this.previewTableData[this.activeAccountId]
      },
      set(newData) {
        // 重新根据定向名称排序，不然切换计划的定向组会出现合并单元格错乱
        newData = groupBy(newData, (plan) => plan.target.name)
        newData = Object.values(newData).flat()
        this.previewTableData[this.activeAccountId] = newData
        this.getTableRowSpan(newData)
      }
    }
  },
  methods: {
    /**
     * @description: 生成已有计划下新增创意组参数
     */
    buildAddCreativeSubmitParams() {
      const [len, planParams] = this.buildSubmitParams()

      const creatives = planParams.planlist.map((plan) => {
        const { plan_name, game_id } = plan.inner_plan_params
        return {
          inner_plan_params: {
            plan_name,
            game_id
          },
          creative_params: plan.creative_params,
          ad_account_id: plan.ad_account_id
        }
      })

      return [len, { creatives }]
    },
    /**
     * @description: 生成批量新增计划参数
     */
    buildSubmitParams() {
      let tableRows = []
      let errorRow = null

      try {
        tableRows = Object.values(this.previewTableData)
          .flat()
          .map((row, index) => {
            errorRow = row
            return {
              ad_account_id: row.plan.account.id,
              inner_plan_params: makeV3InnerPlanParams(row),
              creative_params: makeV3CreativeParams(row, index),
              // 已有计划下新增创意只需要targetingName一个参数，用于根据定向名分组
              outer_plan_params: this.addCreativeFlag
                ? { targeting: { targetingName: row.target.name } }
                : makeV3OuterPlanParams(row, regionList)
            }
          })
      } catch (e) {
        console.log('eeeeeee output: ', e)
        e?.message && this.$Message.warning(e.message)
        if (errorRow) {
          this.activeAccountId = errorRow.plan.account.id
        }
        return
      }

      // 规则：根据定向名称分组；每个组只有一个计划，plan_name计划名称相同；计划下有多个创意，生成任务的个数=创意组的个数
      const groupedByAccountPlanList = groupBy(tableRows, (plan) => plan.ad_account_id)

      const planlist = []
      for (const i in groupedByAccountPlanList) {
        const groupByAccountPlan = groupedByAccountPlanList[i]
        // 根据定向名称分组，分出来的组，每个组只有一个计划，但存在一个或多个创意
        const groupedByTargetingNamePlanList = groupBy(groupByAccountPlan, (plan) => plan.outer_plan_params.targeting.targetingName)

        for (const j in groupedByTargetingNamePlanList) {
          // groupedByTargetingNamePlan内的数组成员属于同一个计划，他们有相同的计划名称
          const groupedByTargetingNamePlan = groupedByTargetingNamePlanList[j]

          for (const k in groupedByTargetingNamePlan) {
            const plan = groupedByTargetingNamePlan[k]
            planlist.push({
              // 同一个计划相同的账号、定向、广告名称、转化、出价
              ...groupedByTargetingNamePlan[0],
              // 同一个计划下多个不同的创意组，需要覆写创意参数
              creative_params: plan.creative_params
            })
          }
        }
      }

      const planParams = {
        batch_task_type: 1,
        operation: this.projectState ? 'enable' : 'disable',
        planlist
      }

      return [planlist.length, planParams]
    },
    /**
     * @description: 批量提交计划
     */
    onPlanSubmit() {
      try {
        const [len, planParams] = this.addCreativeFlag ? this.buildAddCreativeSubmitParams() : this.buildSubmitParams()
        if (!planParams) return
        this.$confirm(`提交${len}个计划, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.submitLoading = true
          ;(this.addCreativeFlag ? submitTencentV3AddCreatives(planParams) : submitTencentV3Plans(planParams))
            .then((data) => {
              if (data) {
                this.$Message.success('提交成功，页面2秒后自动关闭')
                setTimeout(() => {
                  this.clearAndClose()
                }, 2000)
              } else {
                this.submitLoading = false
              }
            })
            .catch(() => {
              this.submitLoading = false
            })
        })
      } catch (e) {
        console.log('eeeeeee output: ', e)
      }
    },

    /**
     * @description: 根据账号、定向、创意分配成计划
     */
    distributePlans() {
      const { planForm, bidForm, targetingGroups, creativeGroups } = this.projectInfo

      // 去掉多余的账号信息，为每个计划单独分配账号
      const { adAccounts, accounts, ...restPlanFormFields } = planForm

      const previewTableData = {}

      // 按定向分组的索引，用于广告计划名称
      let index = 0

      for (const i in this.adAccounts) {
        const account = this.adAccounts[i]
        previewTableData[account.id] = []

        for (const j in targetingGroups) {
          const target = targetingGroups[j]

          const { ch_platform_id, project_name } = restPlanFormFields

          // 如果在已有计划下新增，沿用之前的项目名称
          // 如果是批量新建计划，需要在计划名称后添加序号后缀作为唯一区分
          const projectName = this.addCreativeFlag ? project_name : project_name.concat(`_${++index}`)

          // 用于表格序号显示
          const adIndex = Number(j) + 1

          // 为IOS平台的计划，添加默认落地页配置；
          const defaultIOSPageInfo = {
            pageType: 3,
            page: {}
          }
          let pageInfo = []
          if (ch_platform_id === PLATFORM.IOS) {
            pageInfo = [defaultIOSPageInfo]
          }
          // 为小游戏平台的计划，添加默认落地页配置；
          if (ch_platform_id === PLATFORM.MINIGAME) {
            pageInfo = [{ ...defaultIOSPageInfo, pageType: 4 }]
          }

          for (const k in creativeGroups) {
            const creative = creativeGroups[k]

            previewTableData[account.id].push({
              adIndex,
              // account: 当前计划分配的账号
              plan: { ...restPlanFormFields, account, project_name: projectName },
              bid: clone(bidForm),
              target: clone(target),
              creative: clone({ ...creative, pageInfo }),

              ...getDefaultCheckStates()
            })
          }
        }
      }
      this.getTableRowSpan(previewTableData[this.activeAccountId])
      this.previewTableData = previewTableData
    },
    /**
     * @description: 生成一个以定向名为key的struct，用于辅助表格的合并单元格；
     * @param {*} data
     * @return {*} {[target.name]: [{ rowIndex: number }, { rowIndex: number }]}
     */
    getTableRowSpan(newData) {
      newData = newData.map((row, index) => ({ target: { name: row.target.name }, rowIndex: index }))

      // 根据定向名分组，表格合并单元格时，根据每个定向名下面的计划个数进行合并
      newData = groupBy(newData, (plan) => plan.target.name)
      this.rowSpan[this.activeAccountId] = newData
    },

    onAccountTabChange(acc) {
      // 高亮当前选择的账号
      this.activeAccountId = acc.id
      // 重新计算合并单元格
      this.getTableRowSpan(this.filterdPreviewTableData)
    },

    /**
     * @description: 批量删除当前账号下的计划
     */
    onDistributeRowsRemove() {
      if (!this.tableSelections.length) {
        return this.$Message.error('请选择要删除的计划')
      }
      this.$confirm(`批量删除选择的${this.tableSelections.length}条计划？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const seletedNames = this.tableSelections.map((row) => row.plan.project_name)
        this.filterdPreviewTableData = this.filterdPreviewTableData.filter((row) => {
          return !seletedNames.includes(row.plan.project_name)
        })
      })
    },

    /**
     * @description: 回退上一步，提示已更改的会丢失
     * @return {*}
     */
    onDistributeBackWard() {
      this.$confirm('您正在编辑内容，离开将放弃原来的批量操作，确定要退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.replace({
          name: 'tencentv3Creative',
          query: {
            t: 'edit'
          }
        })
      })
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const label = column.label

      if (rowSpanExcludeLabels.includes(label)) {
      } else {
        const rowSpan = this.rowSpan[this.activeAccountId]
        const n = rowSpan[row.target.name]

        if (rowIndex === n[0].rowIndex) {
          return {
            rowspan: n.length,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },

    /**
     * @description: 获取项目配置信息，并分配计划对应的账号、创意、定向
     * @return {*}
     */
    getProjectInfo() {
      const planForm = getSession('plan_form')
      const bidForm = getSession('bid_form')
      const targetingGroups = getSession('targeting_groups')
      const creativeGroups = getSession('creative_groups')

      this.addCreativeFlag = planForm.addCreativeFlag

      this.projectInfo = {
        planForm,
        bidForm,
        targetingGroups,
        creativeGroups
      }

      // 默认高亮设置第一个账号
      const [activeAccountId] = planForm.accounts
      this.activeAccountId = activeAccountId
      this.distributePlans()
    },
    clearAndClose() {
      clearSession('ada_plan_form')
      clearSession('ada_bid_form')
      clearSession('ada_targeting_groups')
      clearSession('ada_creative_groups')

      window.close()
    },

    getAccountList() {
      return adAccount({ mediaId: 16, authFlag: 1 }).then((data) => {
        this.accountList = data.map((d) => ({ ...d, value: d.name }))
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.ada-distribute {
  .bread {
    margin-bottom: 10px;
  }
}
.config-wrapper {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 15px;
  .plan-tabs {
    .tab-info {
      display: flex;
      font-size: 15px;
      margin-bottom: 6px;

      h5 {
        font-size: 15px;
      }
    }

    .opertions {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 6px;
    }

    .tags {
      .el-tag {
        cursor: pointer;
        margin-right: 5px;
      }
    }
  }
  .table-content {
    .footer-row {
      padding-top: 10px;
      display: flex;
      align-items: center;
      text-align: right;
      justify-content: flex-end;
      .switch {
        display: flex;
        align-items: center;
        margin-right: 10px;
      }
    }
  }
}
</style>
